/**
 * Build the chat message seeded into the Ella embed from a pasted biomarker
 * list, so the customer-support resolver answers coverage deterministically.
 *
 * We seed the pasted list VERBATIM, with no question framing. The resolver
 * treats a message as a list when it yields ≥4 terms after splitting on
 * newlines/commas (`detectListIntent` → `MIN_LIST_ITEMS`), so a bare list trips
 * it directly. Deliberately no lead-in ("Do you offer …"): a prefix would rely
 * on the resolver's English-only prose heuristic to strip it — a cross-repo,
 * English-only coupling that would leak untranslated text into FR/DE/NL
 * transcripts and could resurface as a phantom term if that heuristic changed.
 * The list alone is unambiguous and locale-safe.
 */
export function buildBiomarkerSeedMessage(rawList: string): string {
  return rawList.trim()
}
